import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { PageLoading } from "../common/LoadingSpinner";
import { ROUTES } from "../../constants/constants";

const PublicRoute = ({ children, redirectIfAuthenticated = true }) => {
  const { isAuthenticated, isLoading } = useAuth();

  // Jab tak auth check ho raha hai tab tak loader
  if (isLoading) {
    return <PageLoading message="Loading..." />;
  }

  // Agar user already login hai aur public page (login, forgot, reset) par ja raha hai
  // toh usko dashboard bhej do
  if (redirectIfAuthenticated && isAuthenticated) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  // Warna normally public component render karo
  return children;
};

export default PublicRoute;
